import _ from 'lodash';
import { SgDateUtil } from 'saga-modules';
import SgSptConstants from 'sg-spt-constants';
import CommonConstants from 'sg-common-constants';
import CepConstants from './CepConstants';


const {
    PRODUCT_NAMES,
    PRODUCT_CODES,
    PRODUCT_TYPES,
    RENEWED_POLICY_HEADER,
    TRAVEL_COVER_TYPES
} = CepConstants;

const {
    HOME_COVER_TYPES,
} = CommonConstants;

const getPolicyProductSpecificDetails = (policy) => {
    switch (policy.productCode) {
        case PRODUCT_CODES.PRIVATE_MOTOR: {
            const vehDetails = policy.policyLineInfo.privateMotor.vehicleDTO;
            return {
                name: PRODUCT_NAMES.CAR_INSURANCE,
                coverType: policy.coverLevel,
                vehicle: {
                    make: vehDetails.make,
                    model: vehDetails.model,
                    registration: vehDetails.registrationNumber
                }
            };
        }
        case PRODUCT_CODES.PRIVATE_HOME:
            return {
                name: PRODUCT_NAMES.HOME_INSURANCE,
                coverType: policy.coverLevel,
                postCode: policy.policyHeader.subHeader
            };
        case PRODUCT_CODES.PRIVATE_TRAVEL:
            return {
                name: PRODUCT_NAMES.TRAVEL_INSURANCE,
                coverType: policy.policyLineInfo.privateTravel.productType === SgSptConstants.PRODUCT_TYPE.SINGLE_TRIP
                    ? TRAVEL_COVER_TYPES.SINGLE
                    : TRAVEL_COVER_TYPES.ANNUAL
            };
        case PRODUCT_CODES.PRIVATE_MEDICAL:
            return {
                name: PRODUCT_NAMES.MEDICAL_INSURANCE,
                coverType: policy.coverLevel
            };

        default:
            return {};
    }
};

const setPolicyDetails = (policy) => {
    const isRenewed = policy.policyHeader.currentOrRenewed && policy.policyHeader.currentOrRenewed === RENEWED_POLICY_HEADER;

    const product = {
        price: policy.periods[0].premium.amount.toFixed(2),
        policyNumber: policy.periods[0].policyId,
        type: isRenewed ? PRODUCT_TYPES.RENEWED_POLICY : PRODUCT_TYPES.CURRENT_POLICY
    };

    return Object.assign(product, getPolicyProductSpecificDetails(policy));
};

const getHomeRenewalCoverType = (renewal) => {
    let coverType;
    if (renewal.renewalUpgradeData.hasBuildingCover && renewal.renewalUpgradeData.hasContentsCover) {
        coverType = HOME_COVER_TYPES.BUILDINGS_AND_CONTENTS;
    } else {
        coverType = renewal.renewalUpgradeData.hasBuildingCover ? HOME_COVER_TYPES.BUILDINGS_ONLY
            : HOME_COVER_TYPES.CONTENTS_ONLY;
    }
    return coverType;
};

const getRenewalProductSpecificDetails = (renewal) => {
    switch (renewal.productCode) {
        case PRODUCT_CODES.PRIVATE_MOTOR: {
            const vehDetails = renewal.lobData.privateMotor.coverables.spmVehicle;
            return {
                name: PRODUCT_NAMES.CAR_INSURANCE,
                coverType: renewal.coverLevel,
                vehicle: {
                    make: vehDetails.make,
                    model: vehDetails.model,
                    registration: vehDetails.registrationNumber
                }
            };
        }
        case PRODUCT_CODES.PRIVATE_HOME:
            return {
                name: PRODUCT_NAMES.HOME_INSURANCE,
                coverType: getHomeRenewalCoverType(renewal),
                postCode: renewal.description.split(' ').pop()
            };
        case PRODUCT_CODES.PRIVATE_TRAVEL:
            return {
                name: PRODUCT_NAMES.TRAVEL_INSURANCE,
                coverType: TRAVEL_COVER_TYPES.ANNUAL,
            };
        default:
            return {};
    }
};

const setRenewalDetails = (renewal) => {
    const renewalDetails = renewal.value.renewalDetails ? renewal.value.renewalDetails : renewal.value;
    let product;
    if (!_.isNil(renewalDetails)) {
        product = {
            price: renewalDetails.premium.amount.toFixed(2),
            jobNumber: renewalDetails.jobNumber || renewal.value.jobID,
            policyNumber: renewal.value.policyNumber,
            type: PRODUCT_TYPES.RENEWAL_PROPOSAL,
        };
        if (renewalDetails.availableCoverages) {
            product.addons = renewalDetails.availableCoverages.filter((cov) => cov.selected);
            product.fixedPrice = renewalDetails.fixedPrice || renewal.value.isUpgrading ? 'yes' : 'no';
        }
        if (renewalDetails.periodStart) {
            product.startDate = SgDateUtil.toStringShort(renewalDetails.periodStart);
        }
    }
    return Object.assign(product, getRenewalProductSpecificDetails(renewalDetails));
};

const getRegNumberValue = (regNumber) => {
    // do not send personal information
    return `${regNumber[0]}****${regNumber[regNumber.length - 1]}`;
};

const getVoluntaryAdValue = (amount) => {
    return Number(amount.replace(/[^\d.-]+/g, '')).toString();
};

export default {
    setPolicyDetails,
    setRenewalDetails,
    getRegNumberValue,
    getVoluntaryAdValue
};
